import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Slide, SlideProps, Snackbar } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Alert } from '@material-ui/lab';
import {
  selectToastAutoHide,
  selectToastContent,
  selectToastOpen,
  selectToastType,
  toastAction,
} from 'features/toast/toastSlice';
import { TOAST_AUTO_HIDE_DURATION } from 'constants/common';
import { ReactElement, SyntheticEvent } from 'react';
import { SnackbarCloseReason } from '@material-ui/core/Snackbar/Snackbar';
import { ToastType } from 'types/common/toast';

const ToastMessageContainer = (): ReactElement => {
  const dispatch = useDispatch();
  const open = useSelector(selectToastOpen);
  const type = useSelector(selectToastType);
  const content = useSelector(selectToastContent);
  const autoHide = useSelector(selectToastAutoHide);
  // [EN] Error toasts get an X button and ignore click-away, so the message isn't missed.
  //      Auto-hide still follows the caller's `autoHide` (defaults to false).
  // [KO] 에러 토스트는 X 버튼을 달고 바깥 클릭으로는 닫히지 않게 해 메시지를 놓치지 않게 한다.
  //      자동 닫힘은 호출부의 `autoHide` 를 그대로 따른다 (기본값 false).
  const isError = type === ToastType.ERROR;

  const onClickAwayClose = (): void => {
    if (isError) return;
    dispatch(toastAction.close());
  };

  const onClickCloseButton = (): void => {
    dispatch(toastAction.close());
  };

  const onClose = (event: SyntheticEvent, reason?: SnackbarCloseReason): void => {
    /* Add a conditional statement to prevent the click event
    from being called during rendering.
     * */
    if (reason === 'clickaway') return;
    dispatch(toastAction.close());
  };

  return (
    <>
      <ClickAwayListener mouseEvent="onMouseDown" onClickAway={onClickAwayClose}>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={open}
          onClose={onClose}
          TransitionComponent={SlideUp}
          autoHideDuration={autoHide ? TOAST_AUTO_HIDE_DURATION : null}
        >
          <Alert
            variant="filled"
            severity={type}
            onClose={isError ? onClickCloseButton : undefined}
          >
            {content}
          </Alert>
        </Snackbar>
      </ClickAwayListener>
    </>
  );
};

const SlideUp = (props: SlideProps): ReactElement => {
  return <Slide {...props} direction="up" />;
};

export default ToastMessageContainer;
